import React, { Component } from 'react'
import Settings from '../settings'
import ReactHtmlParser from 'react-html-parser'

// This component:
// 1. University logo
// 2. Basic info
// 3. Credits

import { TimelineMax } from 'TweenMax'
import ScrollMagic from 'scrollmagic'
import 'animation.gsap'
import 'debug.addIndicators'

class Footer extends Component {

  componentDidMount() {
    this.animateEnter()

    // Setup animations once the component is actually in scope
     if (Settings.animation.on && Settings.animation.scroll) {

       // Add 'appear' animation to ScrollMagic
       const scene = new ScrollMagic
       .Scene({triggerElement: '.scroll-start-footer', duration: 3000})
       .setTween( this.animateEnter2() )
       .addTo(this.props.controller)

       // Add in-page markers for debugging - turn off before 'npm run build'
       Settings.animation.scroll_indicators && scene.addIndicators()
     }
  }

  animateEnter2 = () => {
     const tl = new TimelineMax()

     // let elements = document.getElementsByClassName('.h1-top')
     tl.to('.footer-orb', 1, {
        css: {
         y: '-600px'
        },
     })

     return tl
  }

  animateEnter = () => {
      const tl = new TimelineMax()

      // let elements = document.getElementsByClassName('.h1-top')
      tl.from('.Footer', 0.4, {
         css: {
          opacity: 0
         },
        //  ease: Sine.easeInOut
      }, 2)

      return tl
   }

   renderLink = (link,i) => (
      <span key={i} className="footer__link">
         <a href={link.url} target={link.target}>
            {link.title}
         </a>
      </span>
   )

   render() {
      const {
         info = '<p>All events and exhibitions are open to the public unless otherwise noted.</p>',
         colum_2 = `
         <em>Contact</em><br/>
         <a href="mailto:thatdaynow@gmail.com">ThatDayNow@gmail.com</a><br/>
         <a href="http://soa.syr.edu/contact-us">Syracuse Architecture</a><br/>
         <br/>
         <em>Follow</em><br/>
         <a href="http://instagram.com/thatdaynow">Instagram</a><br/>
         <a href="http://twitter.com/syr_arch">Twitter</a>
         `,
         colum_3 = `
         <em>Resources</em><br/>
<a href="https://www.syracuse.edu">Syracuse University</a><br/>
<a href="https://soa.syr.edu">Syracuse Architecture</a><br/>
<a href="http://everson.org">Everson Museum of Art</a><br/>
<a href="http://suart.syr.edu">SU Art Galleries</a><br/>
<a href="http://soe.syr.edu">SU School of Education</a><br/>
<a href="http://humcenter.syr.edu">SU Humanities Center</a>

         `,
         colum_4 = `
         <a href="http://canary-project.org">The Canary Project</a><br/>
<a href="https://soa.syr.edu/live/profiles/576-keiko-ogura">Keiko Ogura</a><br/>
<a href="http://www.pcf.city.hiroshima.jp/hpcf/heiwabunka/pce67/english/67_15E.html">Hiroshima As I Saw It</a><br/>
<a href="http://www.pcf.city.hiroshima.jp/hpcf/english">Hiroshima Peace Culture Foundation</a><br/>
<a href="http://hpmmuseum.jp/?lang=eng">Hiroshima Peace Memorial Museum</a>
         `,
      } = this.props.data

      return (
         <div className="Footer">

            <div className="scroll-start-footer"></div>

            <div>
              <div className="footer-orb"></div>
            </div>

            {/* <div className="footer-share page-width">
               <a href={button_url}><div className="button">{button_text}</div></a>
            </div> */}

            <div className="footer-content">
               <div className="divider divider-dashed divider-white"><svg width="100%"><line x1="100%" y1="0%" x2="0%" y2="0%" stroke="#fff" strokeWidth="1"></line></svg></div>

               <div className="footer-inner page-width row">

                  <div className="col s12 m12 l3">
                     <div>{ReactHtmlParser(info)}</div>

                     <a href="https://soa.syr.edu/" target="_blank" rel="noopener noreferrer"><div className="footer-logo">
                        <svg width="120px" viewBox="0 0 120 53" version="1.1">
                            <title>Syracuse Architecture Logo</title>
                            <g id="logo-group" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="logo" fill="#FEFEFE">
                                    <path d="M6.2606,43.531 L3.5546,43.531 L4.9236,30.781 L6.2606,43.531 Z M-0.0004,52.335 L2.5436,52.335 L3.2936,45.911 L6.5536,45.911 L7.3036,52.335 L9.8476,52.335 L6.7166,28.466 L3.0976,28.466 L-0.0004,52.335 Z M14.0206,31.042 L14.9336,31.042 C16.8256,31.042 17.1186,31.597 17.1186,35.738 C17.1186,38.672 16.6946,39.325 14.7386,39.325 L14.0206,39.325 L14.0206,31.042 Z M11.2816,52.335 L14.0206,52.335 L14.0206,41.835 L15.3576,41.835 L17.9666,52.335 L20.6406,52.335 L17.8686,41.118 C19.3686,40.172 19.9226,38.933 19.9226,36.455 L19.9226,34.042 C19.9226,30.325 18.4556,28.466 15.5206,28.466 L11.2816,28.466 L11.2816,52.335 Z M27.8466,42.357 L27.8466,47.607 C27.8466,49.107 27.3246,49.987 26.2816,49.987 C25.2376,49.987 24.6186,49.107 24.6186,47.607 L24.6186,34.89 C24.6186,32.64 24.6186,30.716 26.1836,30.716 C27.6176,30.716 27.6836,32.379 27.6836,34.205 L27.6836,37.336 L30.3896,37.336 L30.3896,34.107 C30.3896,30.097 28.9546,28.173 25.9876,28.173 C23.3136,28.173 21.8796,30.195 21.8796,33.944 L21.8796,47.379 C21.8796,50.542 23.5096,52.563 26.2486,52.563 C28.9226,52.563 30.5526,50.444 30.5526,47.346 L30.5526,42.357 L27.8466,42.357 Z M32.7696,52.335 L35.4766,52.335 L35.4766,41.346 L38.3786,41.346 L38.3786,52.335 L41.0846,52.335 L41.0846,28.466 L38.3786,28.466 L38.3786,38.836 L35.4766,38.836 L35.4766,28.466 L32.7696,28.466 L32.7696,52.335 Z M43.5626,52.335 L46.3016,52.335 L46.3016,28.466 L43.5626,28.466 L43.5626,52.335 Z M47.4756,30.945 L51.2256,30.945 L51.2256,52.335 L53.9316,52.335 L53.9316,30.945 L57.7146,30.945 L57.7146,28.466 L47.4756,28.466 L47.4756,30.945 Z M59.1156,52.335 L67.1706,52.335 L67.1706,49.792 L61.8556,49.792 L61.8556,41.314 L66.1266,41.314 L66.1266,38.836 L61.8556,38.836 L61.8556,31.01 L66.8116,31.01 L66.8116,28.466 L59.1156,28.466 L59.1156,52.335 Z M74.5716,42.357 L74.5716,47.607 C74.5716,49.107 74.0496,49.987 73.0066,49.987 C71.9626,49.987 71.3436,49.107 71.3436,47.607 L71.3436,34.89 C71.3436,32.64 71.3436,30.716 72.9086,30.716 C74.3436,30.716 74.4086,32.379 74.4086,34.205 L74.4086,37.336 L77.1146,37.336 L77.1146,34.107 C77.1146,30.097 75.6806,28.173 72.7126,28.173 C70.0396,28.173 68.6046,30.195 68.6046,33.944 L68.6046,47.379 C68.6046,50.542 70.2346,52.563 72.9736,52.563 C75.6476,52.563 77.2776,50.444 77.2776,47.346 L77.2776,42.357 L74.5716,42.357 Z M78.3216,30.945 L82.0716,30.945 L82.0716,52.335 L84.7776,52.335 L84.7776,30.945 L88.5596,30.945 L88.5596,28.466 L78.3216,28.466 L78.3216,30.945 Z M98.5056,28.466 L95.7986,28.466 L95.7986,47.509 C95.7986,49.303 95.3096,49.955 94.3966,49.955 C93.2876,49.955 92.8636,49.237 92.8636,47.477 L92.8636,28.466 L90.1576,28.466 L90.1576,47.281 C90.1576,49.4 90.5166,50.542 91.3646,51.389 C92.0816,52.107 93.2876,52.563 94.3636,52.563 C95.5056,52.563 96.5816,52.107 97.3966,51.324 C98.2116,50.476 98.5056,49.4 98.5056,47.411 L98.5056,28.466 Z M103.4936,31.042 L104.4066,31.042 C106.2986,31.042 106.5916,31.597 106.5916,35.738 C106.5916,38.672 106.1676,39.325 104.2116,39.325 L103.4936,39.325 L103.4936,31.042 Z M100.7546,52.335 L103.4936,52.335 L103.4936,41.835 L104.8306,41.835 L107.4396,52.335 L110.1136,52.335 L107.3416,41.118 C108.8416,40.172 109.3956,38.933 109.3956,36.455 L109.3956,34.042 C109.3956,30.325 107.9286,28.466 104.9936,28.466 L100.7546,28.466 L100.7546,52.335 Z M111.7436,52.335 L119.7976,52.335 L119.7976,49.792 L114.4826,49.792 L114.4826,41.314 L118.7536,41.314 L118.7536,38.836 L114.4826,38.836 L114.4826,31.01 L119.4386,31.01 L119.4386,28.466 L111.7436,28.466 L111.7436,52.335 Z" id="architecture"></path>
                                    <path d="M0.5543,16.5212 L0.5543,19.2602 C0.5543,23.3692 2.1193,25.3902 5.2173,25.3902 C8.5753,25.3902 9.5543,22.1622 9.5543,19.4232 C9.5543,16.4882 8.9343,15.0212 6.7823,12.7392 L6.0973,12.0212 C3.5873,9.4452 3.2283,8.6952 3.2283,6.2502 C3.2283,4.3912 3.7173,3.5762 4.8913,3.5762 C6.1303,3.5762 6.5543,4.5542 6.5543,7.5542 L6.5543,9.3802 L9.0653,9.3802 L9.0653,6.6082 C9.0653,3.0222 7.5973,1.0322 4.8913,1.0322 C2.0873,1.0322 0.5543,3.0222 0.5543,6.5762 C0.5543,10.2602 1.8263,11.5972 4.4023,14.3362 C6.0973,16.0972 6.8803,17.0102 6.8803,19.6192 C6.8803,21.7382 6.3263,22.8792 5.1523,22.8792 C3.7503,22.8792 3.1303,21.7062 3.1303,19.2602 L3.1303,16.5212 L0.5543,16.5212 Z M13.4663,15.0862 L13.4663,25.1622 L16.1733,25.1622 L16.1733,15.0212 L19.7273,1.2932 L17.0213,1.2932 L14.8033,11.1732 L12.4883,1.2932 L9.7493,1.2932 L13.4663,15.0862 Z M23.9013,3.8692 L24.8143,3.8692 C26.7053,3.8692 26.9983,4.4242 26.9983,8.5652 C26.9983,11.4992 26.5743,12.1522 24.6183,12.1522 L23.9013,12.1522 L23.9013,3.8692 Z M21.1623,25.1622 L23.9013,25.1622 L23.9013,14.6622 L25.2373,14.6622 L27.8463,25.1622 L30.5203,25.1622 L27.7483,13.9452 C29.2483,12.9992 29.8033,11.7602 29.8033,9.2822 L29.8033,6.8692 C29.8033,3.1522 28.3353,1.2932 25.4013,1.2932 L21.1623,1.2932 L21.1623,25.1622 Z M37.6933,16.3582 L34.9873,16.3582 L36.3563,3.6082 L37.6933,16.3582 Z M31.4333,25.1622 L33.9763,25.1622 L34.7263,18.7382 L37.9873,18.7382 L38.7373,25.1622 L41.2803,25.1622 L38.1503,1.2932 L34.5303,1.2932 L31.4333,25.1622 Z M48.3883,15.1842 L48.3883,20.4342 C48.3883,21.9342 47.8673,22.8142 46.8233,22.8142 C45.7803,22.8142 45.1603,21.9342 45.1603,20.4342 L45.1603,7.7172 C45.1603,5.4672 45.1603,3.5432 46.7253,3.5432 C48.1603,3.5432 48.2253,5.2062 48.2253,7.0322 L48.2253,10.1632 L50.9323,10.1632 L50.9323,6.9342 C50.9323,2.9242 49.4973,1.0002 46.5303,1.0002 C43.8563,1.0002 42.4213,3.0222 42.4213,6.7712 L42.4213,20.2062 C42.4213,23.3692 44.0523,25.3902 46.7913,25.3902 C49.4643,25.3902 51.0953,23.2712 51.0953,20.1732 L51.0953,15.1842 L48.3883,15.1842 Z M61.5293,1.2932 L58.8233,1.2932 L58.8233,20.3362 C58.8233,22.1292 58.3333,22.7822 57.4203,22.7822 C56.3123,22.7822 55.8883,22.0642 55.8883,20.3032 L55.8883,1.2932 L53.1823,1.2932 L53.1823,20.1082 C53.1823,22.2272 53.5403,23.3692 54.3883,24.2162 C55.1053,24.9342 56.3123,25.3902 57.3883,25.3902 C58.5293,25.3902 59.6053,24.9342 60.4203,24.1512 C61.2363,23.3032 61.5293,22.2272 61.5293,20.2382 L61.5293,1.2932 Z M63.2243,16.5212 L63.2243,19.2602 C63.2243,23.3692 64.7903,25.3902 67.8873,25.3902 C71.2463,25.3902 72.2243,22.1622 72.2243,19.4232 C72.2243,16.4882 71.6053,15.0212 69.4523,12.7392 L68.7683,12.0212 C66.2573,9.4452 65.8983,8.6952 65.8983,6.2502 C65.8983,4.3912 66.3873,3.5762 67.5613,3.5762 C68.8003,3.5762 69.2243,4.5542 69.2243,7.5542 L69.2243,9.3802 L71.7353,9.3802 L71.7353,6.6082 C71.7353,3.0222 70.2683,1.0322 67.5613,1.0322 C64.7573,1.0322 63.2243,3.0222 63.2243,6.5762 C63.2243,10.2602 64.4963,11.5972 67.0723,14.3362 C68.7683,16.0972 69.5503,17.0102 69.5503,19.6192 C69.5503,21.7382 68.9963,22.8792 67.8223,22.8792 C66.4203,22.8792 65.8003,21.7062 65.8003,19.2602 L65.8003,16.5212 L63.2243,16.5212 Z M74.1153,25.1622 L82.1693,25.1622 L82.1693,22.6192 L76.8543,22.6192 L76.8543,14.1412 L81.1263,14.1412 L81.1263,11.6622 L76.8543,11.6622 L76.8543,3.8372 L81.8103,3.8372 L81.8103,1.2932 L74.1153,1.2932 L74.1153,25.1622 Z" id="syracuse"></path>
                                </g>
                            </g>
                        </svg>
                     </div></a>
                  </div>

                  {/* <div className="col s12 m9 footer-colums">
                     {ReactHtmlParser(credits)}
                  </div> */}

                  <div className="col s12 m4 l3">
                    {ReactHtmlParser(colum_2)}
                  </div>
                  <div className="col s12 m4 l3">
                    {ReactHtmlParser(colum_3)}
                  </div>
                  <div className="col s12 m4 l3">
                    {ReactHtmlParser(colum_4)}
                  </div>

               </div>
            </div>

         </div>
      )
   }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js